import React from 'react';
import Container from '../../../components/Container';
import ExportsTable from '../components/exports/ExportsTable';
import ReportsTableSection from '../components/exports/ReportsTable';

const Exports = () => (
  <Container gutters={32}>
    <ExportsTable />
    <ReportsTableSection />
  </Container>
);

export default Exports;
